<template>
  <div class="column full-height">
    <h4 class="text-grey-10 full-width text-center text-weight-bold">
      {{ name ? `Welcome ${name}!` : 'Welcome!' }}
    </h4>
    <p class="full-width text-center q-mt-sm q-mb-sm">
      {{ body }}
    </p>
    <SAIFormError class="q-mt-lg" v-if="error" />
    <SAIFormLabel :class="[error ? 'q-mt-md' : 'q-mt-lg']">
      Corporate Email
    </SAIFormLabel>
    <SAIInput
      :disable="disable || loading || user.noCorporateEmail"
      placeholder="Enter your corporate email"
      :large="true"
      type="email"
      :error="error"
      :value="user.companyEmail"
      @input="
        $emit('update:user', {
          ...user,
          companyEmail: $event,
          noCorporateEmail: false
        })
      "
    />
    <SAICheckbox
      :disable="disable || loading"
      class="full-width q-mt-md"
      :val="true"
      label="I don't have a corporate email"
      :value="user.noCorporateEmail"
      @input="
        $emit('update:user', {
          ...user,
          companyEmail: undefined,
          noCorporateEmail: $event
        })
      "
    />
    <QSpace />
    <div class="row justify-center q-mt-lg">
      <SAIBtn
        :disable="disable"
        :loading="loading"
        :label="nextLabel"
        icon-right="eva-arrow-forward-outline"
        :large="true"
        no-caps
        @click="$emit('next')"
      />
    </div>
  </div>
</template>

<script>
import { QSpace } from 'quasar';
import SAIInput from '../../atom/sai-input';
import SAICheckbox from '../../atom/sai-checkbox';
import SAIBtn from '../../atom/sai-btn';
import SAIFormLabel from '../../atom/sai-form-label';
import SAIFormError from '../../molecule/sai-form-error';

export default {
  name: 'SaiUserProfileStepCorporateEmail',
  props: {
    name: String,
    body: {
      type: String,
      default:
        'Now lets link you account to the correct employer for your employer benefits.'
    },
    nextLabel: {
      type: String,
      default: 'Next'
    },
    disable: Boolean,
    loading: Boolean,
    error: Boolean,
    user: {
      type: Object,
      default: () => ({ companyEmail: undefined, noCorporateEmail: false })
    }
  },
  components: {
    SAIInput,
    SAICheckbox,
    SAIBtn,
    SAIFormError,
    QSpace,
    SAIFormLabel
  }
};
</script>
